'use client';

import Icon from '@/components/ui/AppIcon';

const HeroSection = () => {
  return (
    <section id="hero" className="relative min-h-screen bg-gradient-to-br from-primary via-primary/95 to-secondary pt-20 lg:pt-[80px]">
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-accent rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-secondary rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-[1200px] mx-auto px-6 py-16 lg:py-24">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-accent/20 rounded-full mb-6">
              <div className="w-2 h-2 bg-accent rounded-full animate-pulse" />
              <span className="text-sm font-body font-medium text-primary-foreground">
                Gwarancja odpowiedzi w 48 godzin
              </span>
            </div>

            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-headline font-bold text-primary-foreground mb-6 leading-tight">
              Najlepsze warunki kredytu hipotecznego w 48 godzin
            </h1>

            <p className="text-lg lg:text-xl text-primary-foreground/90 mb-4 leading-relaxed">
              Oszczędzamy Twój czas i pieniądze, znajdując najlepsze warunki kredytu hipotecznego dzięki współpracy z wieloma bankami i wieloletniemu doświadczeniu
            </p>

            <div className="flex items-center justify-center lg:justify-start gap-2 mb-8 text-primary-foreground/90">
              <Icon name="MapPinIcon" size={20} variant="solid" className="text-accent" />
              <span className="text-base font-body font-medium">Działamy na terenie całego kraju</span>
            </div>

            <div className="flex flex-wrap gap-6 justify-center lg:justify-start mb-8">
              <div className="flex items-center gap-3">
                <div className="flex items-center justify-center w-12 h-12 bg-accent/20 rounded-lg">
                  <Icon name="CheckCircleIcon" size={24} variant="solid" className="text-accent" />
                </div>
                <div className="text-left">
                  <p className="text-sm font-body font-semibold text-primary-foreground">
                    Bezpłatna konsultacja
                  </p>
                  <p className="text-xs text-primary-foreground/80">
                    Bez zobowiązań
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <div className="flex items-center justify-center w-12 h-12 bg-accent/20 rounded-lg">
                  <Icon name="ClockIcon" size={24} variant="solid" className="text-accent" />
                </div>
                <div className="text-left">
                  <p className="text-sm font-body font-semibold text-primary-foreground">
                    Szybka realizacja
                  </p>
                  <p className="text-xs text-primary-foreground/80">
                    Odpowiedź w 48h
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-card rounded-2xl shadow-2xl p-8">
            <div className="text-center mb-8">
              <div className="flex items-center justify-center w-16 h-16 bg-accent/10 rounded-full mx-auto mb-4">
                <Icon name="EnvelopeIcon" size={32} variant="solid" className="text-accent" />
              </div>
              <h2 className="text-2xl lg:text-3xl font-headline font-bold text-foreground mb-2">
                Skontaktuj się z nami
              </h2>
              <p className="text-sm text-muted-foreground">
                Masz pytania? Napisz do nas bezpośrednio na adres e-mail:
              </p>
            </div>

            <div className="bg-muted/30 rounded-xl p-6 text-center mb-6">
              <a
                href="mailto:biuro@naszahipoteka.pl"
                className="text-lg lg:text-xl font-body font-semibold text-primary hover:text-accent transition-colors duration-250 break-all"
              >
                biuro@naszahipoteka.pl
              </a>
            </div>

            <a
              href="mailto:biuro@naszahipoteka.pl"
              className="w-full flex items-center justify-center gap-2 px-6 py-4 bg-accent text-accent-foreground font-body font-semibold rounded-lg shadow-cta transition-all duration-250 hover:bg-accent/90 hover:shadow-lg"
            >
              <Icon name="PaperAirplaneIcon" size={20} variant="outline" />
              <span>Napisz do nas</span>
            </a>

            <p className="text-xs text-center text-muted-foreground mt-4">
              Odpowiadamy w ciągu 24 godzin w dni robocze
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;